module.exports = __webpack_public_path__ + "img/workbench-bg.4ecb6066.png";